import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import ExternalRedirect from '@app/routes/ExternalRedirect';
import getLoginUrl from '@app/routes/getLoginUrl';

import { APP_BASE_URL } from '../../config/client.config';
import useAuthentication from '../hooks/useAuthentication';

const AuthCheck = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const { loading, isAuthenticated } = useAuthentication();

  return isAuthenticated || loading ? (
    <>{children}</>
  ) : (
    <ExternalRedirect to={getLoginUrl(APP_BASE_URL, location.pathname)} />
  );
};

export default AuthCheck;
